import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ecomsync_item_syncing_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mkt_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_ecomsync_item_syncing_history_RowClass implements bl_fi_mst_ecomsync_item_syncing_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    mkt_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
